export default __webpack_public_path__ + "static/media/raidguild_mark.c7d9f383.png";